import { RootState } from 'handlers';

export const getFinancialMetricsState = (state: RootState) => state.financialMetrics;
